import { ISingleIdParams } from '../types/actionParams';
import { IDataRoleActions } from '../types/IDataRoleActions';
import { Request } from './Request';

export class GetDataRoleActionsRequest extends Request<ISingleIdParams, IDataRoleActions> {
  constructor(id: string) {
    super('getDataRoleActions', { id: id });
  }
}
